export enum Icon {
  Arrow,
  BoldArrow,
  Calendar,
  Caret,
  Check,
  Close,
  Dashboard,
  Document,
  Eye,
  Filter,
  Help,
  Health,
  Less,
  Logo,
  More,
  NoContract,
  PDF,
  Pencil,
  Refresh,
  Report,
  RoundLess,
  RoundCaret,
  RoundCheck,
  RoundFillCheck,
  RoundMore,
  RoundNoContract,
  RoundNoSign,
  RoundWarning,
  Search,
  StarFull,
  StarOutline,
  Triangle,
  Warning,
  Padlock,
  Download,
  Flag,
  ProfilePhoto,
  PhotoCamera,
  Avatar,
  Device,
}
